/* Zeus product spec tables (assets/zeus-product-specs.css).
 *
 * Finds a "Technical Specs" (or "Specifications") heading in a product
 * description and turns the list under it into a two-column table, splitting
 * each row into label and value on the first colon.
 *
 * Done in the browser rather than baked into the description HTML on purpose:
 * descriptions are edited by people in admin, and a class attribute is the
 * first thing lost to a copy-paste or a rich-text editor. Matching on the
 * heading text means the house pattern - "Technical Specs" followed by a list
 * of "Label: value" - styles itself on every product that already uses it,
 * with nothing to remember when writing the next one.
 *
 * If this never runs, the list renders as an ordinary bulleted list.
 */
(() => {
  const root = document.querySelector('.product__description');
  if (!root) return;

  const HEADING = /^\s*(technical\s+specs?|specifications?|specs?)\s*:?\s*$/i;

  for (const head of root.querySelectorAll('h1, h2, h3, h4, h5, h6')) {
    if (!HEADING.test(head.textContent)) continue;

    const list = head.nextElementSibling;
    if (!list || list.tagName !== 'UL' || list.classList.contains('zeus-specs')) continue;

    let converted = 0;
    for (const li of [...list.children]) {
      if (li.tagName !== 'LI') continue;

      // Prefer the leading <strong> as the label; fall back to text before the
      // first colon so hand-typed rows still line up.
      const strong = li.querySelector('strong, b');
      let label, valueNodes;

      if (strong && li.firstElementChild === strong) {
        label = strong.textContent;
        valueNodes = [...li.childNodes].filter((n) => n !== strong);
      } else {
        const text = li.textContent;
        const i = text.indexOf(':');
        if (i < 1) continue;
        label = text.slice(0, i);
        valueNodes = [document.createTextNode(text.slice(i + 1))];
      }

      const k = document.createElement('span');
      k.className = 'zeus-specs__k';
      k.textContent = label.replace(/\s*:\s*$/, '').trim();

      const v = document.createElement('span');
      v.className = 'zeus-specs__v';
      for (const n of valueNodes) v.appendChild(n);
      v.textContent = v.textContent.replace(/^\s*:?\s*/, '');

      li.textContent = '';
      li.append(k, v);
      converted++;
    }

    if (converted) {
      list.classList.add('zeus-specs');
      head.classList.add('zeus-specs__head');
    }
  }
})();
